import { logger } from '@/modules/common/logging/logger';

import { OrderProfile } from '../types';
import { IOrderProfileService } from './IOrderProfileService';

export class OrderProfileServiceLogDecorator implements IOrderProfileService {
  private decoree: IOrderProfileService;

  constructor(decoree: IOrderProfileService) {
    this.decoree = decoree;
  }

  getOrderProfile(): OrderProfile | null {
    const start = this.logStart('getOrderProfile');
    const orderProfile: OrderProfile | null = this.decoree.getOrderProfile();
    this.logEnd('getOrderProfile', start);
    return orderProfile;
  }

  setPanelOpen(value: boolean): void {
    const start = this.logStart('setPanelOpen');
    this.decoree.setPanelOpen(value);
    this.logEnd('setPanelOpen', start);
  }

  setOrderProfile(orderProfile: OrderProfile): void {
    const start = this.logStart('setOrderProfile');
    this.decoree.setOrderProfile(orderProfile);
    this.logEnd('setOrderProfile', start);
  }

  // private utility methods

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
